/** Gap between virtualized message rows — matches the list's former `gap-3` / per-row `pb-3`. */
export const WORKSPACE_AGENT_MESSAGE_ROW_GAP_PX = 12;

/** Top padding on the virtualized list — matches the list's former `pt-3`. */
export const WORKSPACE_AGENT_MESSAGE_ROW_PADDING_START_PX = 12;
